import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.5191 5.87593C16.8565 6.16896 16.9374 6.67262 16.6897 7.06056L16.6085 7.16939C16.3154 7.50674 15.8118 7.58762 15.4239 7.33998L13.2042 5.92312L13.2042 18.9172L13.1959 19.0416C13.1352 19.489 12.7516 19.8339 12.2876 19.8339C11.7813 19.8339 11.3709 19.4235 11.3709 18.9172L11.3709 5.9057L9.06901 7.34451L8.9489 7.40791C8.53941 7.58679 8.0498 7.4436 7.80576 7.05339C7.53732 6.62416 7.66766 6.05858 8.09689 5.79014L11.7972 3.47591C11.8999 3.41078 12.0164 3.3655 12.1413 3.34547C12.2378 3.32989 12.3362 3.32983 12.4327 3.34529C12.5605 3.36562 12.6795 3.41238 12.784 3.47977L16.4103 5.79467L16.5191 5.87593Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }